import React from 'react'
import { FaFacebook, FaInstagram } from 'react-icons/fa';

import Map from '../../images/map.png';
import { useTranslation } from 'react-i18next'; 


import { 
    FooterDiv,
    InfosFooter,
    InfoRedes,
    FooterLinks,
    InfoP,
    MapFooter,
    MapImg
 } from './FotterElements';

const Footer = () => {
    const { t } = useTranslation();
  return (
    <>
        <FooterDiv>
            <InfosFooter>
                <InfoRedes>
                    <FooterLinks target="blank" to="https://www.facebook.com/varandasbonitoms/"><FaFacebook /></FooterLinks>
                    <FooterLinks target="blank" to="https://www.instagram.com/varandasbonitoms"><FaInstagram /></FooterLinks>

                </InfoRedes>

                <InfoP>
                    {t('footer.contato')}: 67 9 9142-4788<br/>
                    {t('footer.endereco')}: {t('footer.rua')} Pilad Rebua, 1883<br/>
                    Centro, Bonito - MS, 79290-000<br/>
                    {t('footer.distancia')}<br/>
                </InfoP>
            </InfosFooter>

            <MapFooter target= "blank" to="https://maps.app.goo.gl/7iFJ4YdYSV3yNab7A">
            <p style={{
                fontSize : '14px',
                color: '#fff',
                textAlign: 'right',
                border: 'solid 5px #FF9746',
                }
                
            }
                
                >
                    {t('footer.mapa')}</p>
                <MapImg src={Map} />
            </MapFooter>
        </FooterDiv>
      
    </>
  )
}

export default Footer;
